const BASE = location.hostname === '127.0.0.1' ?
    'http://127.0.0.1:3000/shopify-apihub/flexpatio' :
    'https://shopify-api-846519286311.northamerica-northeast2.run.app/shopify-apihub/flexpatio'

// const BASE = 'https://shopify-api-846519286311.northamerica-northeast2.run.app/shopify-apihub/flexpatio'

const COUNTRY = document.documentElement.dataset.country

const _request = async (url, options = {}) => {
    const res = await fetch(`${BASE}${url}`, options)

    let result
    try {
        result = await res.json()
    } catch {
        throw new Error('接口返回格式错误')
    }

    const { code, msg, data } = result

    if (!res.ok || code !== 200) {
        const error = new Error(msg || result.message || `请求失败：${res.status}`)
        error.code = result.error || code
        error.statusCode = result.statusCode || res.status
        error.requestId = result.requestId
        throw error
    }

    return data
}

const http = {
    post: async ({ url, data = {}, isFormData = false }) => {
        if (isFormData) {
            data.append('country', COUNTRY)

            return _request(url, {
                method: 'POST',
                body: data
            })
        }

        return _request(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ...data,
                country: COUNTRY
            })
        })
    }
}

globalThis.API = {
    getInstallationQuote: async (data) => {
        return await http.post({
            url: '/installation/quote',
            data
        })
    },
    getFreightQuote: async (data) => {
        return await http.post({
            url: '/freight/quote',
            data
        })
    },
    getConfigurationPriceQuote: async (data) => {
        return await http.post({
            url: '/configuration-price/quote',
            data
        })
    },
    checkZipCode: async (zipCode) => {
        return await http.post({
            url: '/zip-code/check',
            data: { zipCode }
        })
    },
    addMatchYourPergolaQuiz: async (form) => {
        await http.post({
            url: '/match-your-pergola/add-quiz-record',
            data: { form }
        })
    },
    addLearnMoreQuiz: async (form) => {
        await http.post({
            url: '/learn-more/add-quiz-record',
            data: { form }
        })
    },
    uploadFiles: async (...files) => {
        const formData = new FormData()
        for (const file of files) {
            formData.append('files', file)
        }

        return await http.post({
            url: '/upload/upload-files',
            data: formData,
            isFormData: true
        })
    },
    requestQuote: async (data) => {
        return await http.post({
            url: `/gorgias/request-a-quote`,
            data
        })
    },
    requestShowroomVisit: async (form) => {
        return await http.post({
            url: `/showroom/request-showroom-visit`,
            data: {
                form
            }
        })
    },
    hostShowroom: async (form) => {
        return await http.post({
            url: `/showroom/host-showroom`,
            data: {
                form
            }
        })
    },
    addFbclidRecord: async (data) => {
        return await http.post({
            url: `/click-ads/add-fbclid`,
            data
        })
    },
    addGclidRecord: async (data) => {
        return await http.post({
            url: `/click-ads/add-gclid`,
            data
        })
    },
    uploadPdfFiles: async (...files) => {
        const formData = new FormData()
        for (const file of files) {
            formData.append('files', file)
        }

        return await http.post({
            url: '/upload/upload-pdf-files',
            data: formData,
            isFormData: true
        })
    },
    saveV3Configuration: async (data) => {
        return await http.post({
            url: `/saveV3Configuration`,
            data
        })
    },
    getPatioRendering: async (data) => {
        return await http.post({
            url: `/getPatioRendering`,
            data
        })
    }
}
